import React, { useState } from 'react'
import { Fade } from 'react-awesome-reveal'
import { useTranslation } from 'next-i18next'

import { css } from '@emotion/react'
import html from 'html-react-parser'

import CustomReveal from '@/components/common/CustomReveal'
import { colors } from '@/styles/theme'
import { mediaUp } from '@/styles/media'
import { Text2Styles } from '@/styles/typography'
import { Grid, mediaColumns } from '@/styles/grid'
import Title from '@/components/common/Title'

import Form from '@/components/landing/Form2'

function FormSection() {
  const { t } = useTranslation('landing')
  const [sended, setSended] = useState(false)

  const handleSended = (value: boolean) => {
    setSended(value)
  }

  const thankYouContent = (
    <>
      <Title light text={t('saudiExpo.form.thankYou.title')} />
      <div css={description}>{t('saudiExpo.form.thankYou.description')}</div>
    </>
  )

  return (
    <section css={container} id="register-section">
      {!sended && (
        <CustomReveal>
          <>
            <Title text={t('saudiExpo.form.title')} css={title} light />
            <div css={subtitle}>{html(t('saudiExpo.form.subtitle'))}</div>
          </>
        </CustomReveal>
      )}
      <Fade>
        <Grid>
          <div css={column}>
            <Form
              onClick={handleSended}
              buttonText={t('saudiExpo.form.button')}
              thankYouContent={thankYouContent}
            />
          </div>
        </Grid>
      </Fade>
    </section>
  )
}

const container = css`
  background: ${colors.darkSkyBlue};
  padding: 40px 0;

  ${mediaUp('lg')} {
    padding: 80px 0;
  }
`
const column = css`
  ${mediaColumns({ xs: [10, 1], md: [8, 2] })};
`

const title = css`
  padding: 0 20px;

  ${mediaUp('md')} {
    br {
      display: none;
    }
  }

  ${mediaUp('lg')} {
    padding: 0 40px;
  }
`

const subtitle = css`
  ${Text2Styles};
  color: ${colors.white};
  text-align: center;
  padding: 20px;

  ${mediaUp('lg')} {
    padding: 40px;
  }
`

const description = css`
  ${Text2Styles};
  color: ${colors.white};
  text-align: center;
  padding-top: 20px;

  ${mediaUp('lg')} {
    padding-top: 40px;
  }
`

export default FormSection
